import { FormControl, InputLabel, Select, Checkbox, ListItemText, ListSubheader, MenuItem, OutlinedInput, Button } from '@mui/material';
import { ROAD_LABELS, ROAD_LABELS_NAMES, ROAD_LABELS_NAMES_LENGTH, TABLE_COLS } from '../constants';

export default function FiltersOptions({labelFilters, setLabelFilters}) {

  return (
    <FormControl fullWidth>
      <InputLabel htmlFor="select-labels">
        Filters:
      </InputLabel>
      <Select
        multiple
        className='roads-selection'
        input={<OutlinedInput label='Filters' />}
        value={labelFilters}
        renderValue={(selected) =>
          selected.length === ROAD_LABELS_NAMES_LENGTH
            ? 'All'
            : 'Some'
        }
        onChange={(e) => { setLabelFilters(e.target.value) }}
        style={{ textAlign: 'start' }}
      >
        <ListSubheader>
          <Button variant='text' onClick={() => { setLabelFilters(ROAD_LABELS_NAMES) }}>Select All Filters</Button>
          <Button variant='text' onClick={() => { setLabelFilters([]) }}>Deselect All Filters</Button>
        </ListSubheader>
        {/* Map function returns as an array because MUI does not accept a React Fragment as a child of Select */}
        {ROAD_LABELS.map(c => [
          <ListSubheader>
            {c.category}
            <Button variant='text' onClick={() => { setLabelFilters(prev => {
              let newElements = []
              ROAD_LABELS_NAMES.filter(d => d.includes(c.categoryKey)).forEach(l => {
                if (!prev.includes(l)) {
                  newElements.push(l)
                }
              })
              return [...prev, ...newElements]
            }) }}>Select All</Button>
            <Button variant='text' onClick={() => { setLabelFilters(prev => prev.filter(d => !d.includes(c.categoryKey))) }}>Deselect All</Button>
          </ListSubheader>,
          Object.keys(c.labels).map(label =>
            <MenuItem key={label} value={`${c.categoryKey}-${c.labels[label]}`}>
              <Checkbox checked={labelFilters.includes(`${c.categoryKey}-${c.labels[label]}`)} />
              <ListItemText primary={label} />
            </MenuItem>
          )
        ])}
      </Select>
    </FormControl>
  )
}